import React, {Component} from 'react';
import ReactDOM from "react-dom";
import staticVehicleLists from"./staticVehicleLists";
import { DocumentUploadModal } from "./DocumentUploadModal";

export class VehicleDetails extends Component{
    constructor(props){
        super(props);
        this.state = {
                        documentsUploaded: false,
                        vehicleModelList: null,
                        specifyDifferentAddress: false,
                    };
        this.handleChange = this.handleChange.bind(this);
        this.fetchDataForVIN = this.fetchDataForVIN.bind(this);
        this.fetchModelsForMake = this.fetchModelsForMake.bind(this);
        this.handleSpecificChanges = this.handleSpecificChanges.bind(this);
        this.updateSpecifyAddress = this.updateSpecifyAddress.bind(this);
    }

    static defaultVehicleInputData = {"VIN":"", "Make":"", "Model":"","Year": 1970,"Condition":"","Value":0,
                                "fromAuction":true, "memberNumber":"", "lotNumber":"", "title":"", 
                                "differentAddressSpecified": "false", "pickupStreetAddress": "",
                                "pickupStreetAddress": "","pickupCity": "", "pickupState": "",
                                "pickupZipcode": ""
                            };
    
    componentDidMount(){
        const node = ReactDOM.findDOMNode(this);
        if(this.props.id != 0){
           node.scrollIntoView({behavior: "smooth", block: "nearest", inline: "start"});
        }
    }

    updateSpecifyAddress(value){
        this.setState({specifyDifferentAddress : value});
    }

    fetchDataForVIN(event){
        var VIN = event.target.value;
        
        if(VIN.length != 17){
            return;
        }
        var keyValuePairs = {keys: ["Make","Model","Year"], values: []};
        fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVin/' + VIN + '?format=json')
            .then(response => response.json())
            .then(data => {
                keyValuePairs.values[0] = data["Results"]["6"]["Value"];
                keyValuePairs.values[1] = data["Results"]["8"]["Value"];
                keyValuePairs.values[2] = data["Results"]["9"]["Value"];
                
                this.props.onUpdateMultiple(this.props.id, keyValuePairs);
            });
    }

    fetchModelsForMake(event){
        var make = event.target.value;
        
        if(make.length == 0){
            return;
        }
        var innerData,dataList;
        fetch('https://vpic.nhtsa.dot.gov/api/vehicles/GetModelsForMake/' + make + '?format=json')
            .then(response => response.json())
            .then(data => {
                innerData = data["Results"].map((result,index) => <option key={index}>{result["Model_Name"]}</option>);
                dataList = <datalist id={"modelList" + this.props.id}>{innerData}</datalist>;     
                this.setState({vehicleModelList: dataList});
            });
    }
    
    handleChange(event){
        var nameSplitArray = event.target.name.split(".");
        
        var key = nameSplitArray[nameSplitArray.length-1];
        var value=event.target.value;
        
        this.props.onUpdate(this.props.id, key, value);
    }

    handleSpecificChanges(values){
    }


    // TODO: Implement autocollapse of vehicle with a display that includes a summary of the entered details
    // TODO: Implement AJAX to populate the options found in lists. Hardcoding this currently for efficency sake
    render(){
        var inputFor = this.props.inputFor;
        var VINinput = inputFor + "[" + this.props.id + "].VIN";
        var makeInput = inputFor + "[" + this.props.id + "].Make";
        var modelInput = inputFor + "[" + this.props.id + "].Model";
        var yearInput = inputFor + "[" + this.props.id + "].Year";
        var conditionInput = inputFor + "[" + this.props.id + "].Condition";
        var valueInput = inputFor + "[" + this.props.id + "].Value";
        var fromAuction = inputFor + "[" + this.props.id + "].fromAuction";
        var memberInput = inputFor + "[" + this.props.id + "].memberNumber";
        var lotInput = inputFor + "[" + this.props.id + "].lotNumber";
        var conditionToolTip = inputFor + "[" + this.props.id + "].conditionToolTip";

        var differentAddressSpecifiedInput = inputFor + "[" + this.props.id + "].differentAddressSpecified";
        var pickupStreetAddressInput = inputFor + "[" + this.props.id + "].pickupStreetAddress";
        var pickupCityInput = inputFor + "[" + this.props.id + "].pickupCity";
        var pickupStateInput = inputFor + "[" + this.props.id + "].pickupState";
        var pickupZipcode = inputFor + "[" + this.props.id + "].pickupZipcode";

        var modelListName = "modelList" + this.props.id;
        var removeButton,yearOptionsList,documentUploadConf;
        
        var years = [];
        for(var i = 1970; i <= new Date().getFullYear(); i++){
            years.push(i.toString());
        }
        yearOptionsList = years.map((year,index) => <option key={index} value={year}>{year}</option>)
        // If inputting RORO vehicles, don't display remove button when only
        // one vehicle card is displayed
        if(inputFor === "vehicleInfo"){
            if(this.props.totalVehicles != 1){
                removeButton = 
                <button type="button" className="btn btn-outline-danger btn-rounded waves-effect"
                    onClick={() => this.props.onRemoveVehicle(this.props.id)}>
                        Remove
                </button>
            }
        }
        // If inputting in any other context, all vehicles can be removed
        else{
            removeButton = 
            <button type="button" className="btn btn-outline-danger btn-rounded waves-effect"
                onClick={() => this.props.onRemoveVehicle(this.props.id)}>
                    Remove
            </button>
        }
        
        var auctionDetails = 
            <div className="row m-1">
                <div className="col-md-6 col-sm-12 mt-sm-2">
                    <label className="control-label">Lot Number</label>                
                    <input required name={lotInput} value={this.props.value["lotNumber"]} className="form-control"
                        onChange={this.handleChange}/>
                </div>
                <div className="col-md-6 col-sm-12 mt-sm-2">
                    <label className="control-label">Member Number</label>                
                    <input required name={memberInput} value={this.props.value["memberNumber"]} className="form-control"
                        onChange={this.handleChange}/>
                </div>
            </div>
        
        var auctionSection;
        
        if(this.props.value["fromAuction"] === "true" || this.props.value["fromAuction"] === true){     
            auctionSection =             
                <div className="col-12 mt-2">       
                    <div className="ml-2 form-check form-check-inline">
                        <input type="radio" className="form-check-input" id={"Vehicle-From-Auction"+this.props.id}
                            name={fromAuction} value={true} checked onClick={this.handleChange}/>
                        <label className="form-check-label" htmlFor={"Vehicle-From-Auction"+this.props.id}>Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input type="radio" className="form-check-input" id={"Vehicle-Not-From-Auction" + this.props.id}
                            name={fromAuction} value={false} onClick={this.handleChange}/>
                        <label className="form-check-label" htmlFor={"Vehicle-Not-From-Auction"+this.props.id}>No</label>
                    </div>
                    {auctionDetails}
                </div>
        }
        else{
            auctionSection = 
                <div className="col-12 mt-2"> 
                    <div className="ml-2 form-check form-check-inline">
                        <input type="radio" className="form-check-input" id={"Vehicle-From-Auction"+this.props.id}
                            name={fromAuction} value={true} onClick={this.handleChange}/>
                        <label className="form-check-label" htmlFor="Vehicle-From-Auction">Yes</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input type="radio" className="form-check-input" id={"Vehicle-From-Auction"+this.props.id}
                            name={fromAuction} value={false} checked onClick={this.handleChange}/>
                        <label className="form-check-label" htmlFor="Vehicle-Not-From-Auction">No</label>
                    </div>                
                </div>
        }

        //#region Different pickup address details:
        var differentPickupAddress = 
            <div id={"Specific-Pickup-Address-Card"+this.props.id} className="col-sm-12">
                <div className="card border p-2">
                    <div className="h5 mb-2">Pickup Address</div>                
                    <div className="row">
                        <div className="col-md-12 col-sm-9">
                            <label className="control-label">Full Street Address</label>                
                            <input required name={pickupStreetAddressInput} className="form-control" 
                                value={this.props.value["pickupStreetAddress"]}
                                onChange={this.handleChange} autoComplete="off"/>
                        </div>  
                        <div className="col-md-6 col-sm-9 mt-sm-2">
                            <label className="control-label">City</label>                
                            <input required name={pickupCityInput} className="form-control"
                                value={this.props.value["pickupCity"]}
                                onChange={this.handleChange} autoComplete="off"/>
                        </div>
                        <div className="col-md-6 col-sm-8 mt-sm-2">
                            <label className="control-label">State</label>
                            <input required name={pickupStateInput} className="form-control"
                                value={this.props.value["pickupState"]}
                                onChange={this.handleChange} autoComplete="off"/>
                        </div>
                        <div className="col-md-6 col-sm-8 mt-sm-2">
                            <label className="control-label">ZIP Code</label>
                            <input required name={pickupZipcode} className="form-control"
                                value={this.props.value["pickupZipcode"]}
                                onChange={this.handleChange} autoComplete="off"/>
                        </div>
                        <div className="col-md-6 col-sm-8 mt-sm-2">
                            <label className="control-label">Country</label>
                            <input required readOnly aria-disabled="true" className="form-control readOnly" 
                                value="US"autoComplete="off"/>
                        </div>
                    </div>
                </div>
            </div>
        if(this.state.documentsUploaded){
            documentUploadConf = <div className="col-12"> <em>Documents uploaded</em> </div>;
        }else{
            documentUploadConf = <div className="col-12 small"> <em>Upload title and other documents</em> </div>;
        }
        return(
            // Individual vehicle details
            <div className="row align-items-center mb-2">
                <div className="col-sm-3">                    
                    <strong>Vehicle #{parseInt(this.props.id,10) + 1}</strong>
                </div>
                <div className="col-sm-9">
                    {removeButton}
                </div>
                <div className="col-12">
                    <label className="control-label">Vehicle VIN #</label>
                </div>
                <div className="col-md-4 col-sm-6 mt-2 mt-md-0">                    
                    <input name={VINinput} className="form-control vinlength" value={this.props.value["VIN"]}
                        onBlur={this.fetchDataForVIN} onChange={this.handleChange}/>
                </div>
                <div className="w-100"></div>

                <div className="col-md-4 col-sm-6 mt-2 mt-md-0">
                    <label className="control-label">Make</label>                
                    <input required name={makeInput} className="form-control" value={this.props.value["Make"]}
                        onBlur={this.fetchModelsForMake} onChange={this.handleChange} list="makeList"/>
                    {staticVehicleLists.vehicleMakeList("makeList")}
                </div>
                <div className="col-md-4 col-sm-6 mt-2 mt-md-0">
                    <label className="control-label">Model</label>
                    <input required name={modelInput} className="form-control" value={this.props.value["Model"]}
                        onChange={this.handleChange} list={modelListName}/>
                    {this.state.vehicleModelList}
                </div>
                <div className="col-md-4 col-sm-6 mt-2 mt-md-0">
                    <label className="control-label">Year</label>
                    <select required name={yearInput} className="form-select" value={this.props.value["Year"]}
                        onChange={this.handleChange}
                        >
                    {yearOptionsList}
                    </select>
                </div>   
                <div className="col-md-4 col-sm-6 mt-2 mt-md-0">
                    <label className="control-label">Vehicle condition</label>
                    <span className="dropdown">
                        <a id={conditionToolTip} data-toggle="dropdown" className="badge bg-info dropdown-toggle ml-2" aria-expanded="false">Info</a>
                        <div className="dropdown-menu" style={{"max-width":"800px","width":"90vw"}} aria-labelledby={conditionToolTip}>
                            <div className="alert alert-info mb-0 pb-n1 border border-black">
                                <ul>
                                    <li className="mb-1">Choose <strong>Non-Running</strong> if the vehicle does not start, but can be moved/rolled on its own set of wheels.</li>
                                    <li className="mb-1">Choose <strong>Needs forklift trailer</strong> if the vehicle does not start, and cannot be moved/rolled on its own wheels.</li>
                                    <li>If you are unsure, choose <strong>Running</strong>.</li>
                                </ul>
                            </div>
                        </div>
                    </span>
                    
                    <select name={conditionInput} className="form-select" value={this.props.value["Condition"]}
                        onChange={this.handleChange}>
                        <option value={0}>Running</option>
                        <option value={1}>Non-running</option>
                        <option value={2}>Needs forklift trailer</option>
                    </select>
                </div>
                <div className="col-md-4 col-sm-6 mt-2 mt-md-0">
                    <label className="control-label">Value ($)</label>
                    <input type="number" required name={valueInput} className="form-control" value={this.props.value["Value"]}
                        onChange={this.handleChange} min="0"/>
                </div>  
                <div className="col-md-8 col-sm-12 mt-2">
                    <em className="mt-2">Is this vehicle being picked up at an auction?</em>                            
                    {auctionSection}
                </div>
                <DocumentUploadModal inputFor={inputFor} id={this.props.id}/>
                <div className="col-12">
                    <strong className="mr-2">Specify different pickup address?</strong>
                    <div className="form-check form-check-inline mb-1">
                        <input type="radio" className="form-check-input"
                            id={"Specify-Different-Address"+this.props.id} name={differentAddressSpecifiedInput}
                            checked={this.props.value["differentAddressSpecified"] === "true"} value="true"
                            onClick={(evt) => {this.updateSpecifyAddress(true); this.handleChange(evt) }}/>
                        <label className="form-check-label" htmlFor={"Specify-Different-Address"+this.props.id}>
                            Yes
                        </label>
                    </div>
                    <div className="form-check form-check-inline my-1">
                        <input type="radio" className="form-check-input"
                            id={"Dont-Specify-Different-Address"+this.props.id} name={differentAddressSpecifiedInput}
                            checked={this.props.value["differentAddressSpecified"] === "false"} value="false"
                            onClick={(evt) => { this.updateSpecifyAddress(false); this.handleChange(evt) } }/>
                        <label className="form-check-label" htmlFor={"Dont-Specify-Different-Address"+this.props.id}>
                            No
                        </label>
                    </div>
                    <div className="row">
                        {(this.props.value["differentAddressSpecified"] === "true")
                            &&                         
                            differentPickupAddress
                        }
                    </div>                    
                </div>
            </div>
        )
    }

    
}